import { render, staticRenderFns } from "./Internation.vue?vue&type=template&id=500cf50b&scoped=true&"
import script from "./Internation.vue?vue&type=script&lang=js&"
export * from "./Internation.vue?vue&type=script&lang=js&"
import style0 from "./Internation.vue?vue&type=style&index=0&id=500cf50b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500cf50b",
  null
  
)

export default component.exports